import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
	display: flex;
	align-items: center;
	background: none;
	border: none;
	outline: none;

	& .line {
		width: 30px;
		height: 3px;
		background-color: black;
		display: block;
		margin: 6px auto;
		transition: all 400ms ease-in-out;
	}
	&.is-active .line:nth-child(2) {
		opacity: 0;
	}

	&.is-active .line:nth-child(1) {
		transform: translateY(9px) rotate(45deg);
	}

	&.is-active .line:nth-child(3) {
		transform: translateY(-9px) rotate(-45deg);
	}
`;

const MenuButton = ({ handleClick, isOpen }) => {
	return (
		<Button onClick={handleClick} className={isOpen ? 'is-active' : ''}>
			<span className="line" />
			<span className="line" />
			<span className="line" />
		</Button>
	);
};

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton.js